import {get} from 'lodash';

import {getCacheKey} from '/util/records.util';

export default (
  state = {},
  {reportName, reportParams, stateName, stateValue, filtersData}: any,
) => {
  const reportKey = getCacheKey({
    recordsName: reportName,
    recordsParams: reportParams,
    filtersData,
  });

  return {
    ...state,
    allReportState: {
      ...get(state, 'allReportState', {}),
      [reportKey]: {
        ...get(state, `allReportState.${reportKey}`, {}),
        [stateName]: stateValue,
      },
    },
  };
};
